import React from "react";
import rollbarErrorTracking from "../utils/rollbarErrorTracking";

class ErrorBoundary extends React.Component {
  componentDidCatch(error, info) {
    rollbarErrorTracking.logErrorInRollbar(error);
    if (info) {
      rollbarErrorTracking.logErrorInfo(info);
    }
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
